import { render } from "./Shop.vue?vue&type=template&id=38c480e2&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=38c480e2&lang=css"
import "./Shop.vue?vue&type=style&index=1&id=38c480e2&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c480e2"]])

export default __exports__